import { nabBar } from '../typesActions/types';

export const toggleOpenOrCloseNavBar = ({ status }) => {
	return { type: nabBar.OPEN_OR_CLOSE, status };
};
